// Section heading with an optional short explanation under it
const CustomTitle = ({ title, hoverText = '', customClass = '', as: Tag = 'h2' }) => (
  <div className={customClass}>
    <Tag className="cbSectionTitle">{title}</Tag>
    {hoverText ? <p className="cbHint">{hoverText}</p> : null}
  </div>
)

export default CustomTitle
